import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import PuzzleRandomizer from "../util/PuzzleRandomizer";

export default class GameConfig extends Config {
    /**
     * @constructor
     * @param {AppModel} appModel 
     */
    constructor(appModel) {
        super();

        this._appModel = appModel;
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        if (getURLParameter("randomization") === "0") {
            if (ranj.DEBUG) console.log("GameConfig: Using fixed levels.");
            this._puzzles = this.getValue("puzzles");
            this._practicePuzzles = this.getValue("practicePuzzles");
        } else {
            if (ranj.DEBUG) console.log("GameConfig: Using random levels.");
            let rulesetIndex = PuzzleRandomizer.generateRuleIndex(this.getValue("randomizedPuzzles"));
            if (getURLParameter("ruleset") != null) {
                rulesetIndex = parseInt(getURLParameter("ruleset"));
            }

            // Use url parameters to use fixed location (by postfix, e.g.: '2' in 'Pond2') or rule (by index) 
            const overrides = {};
            if (!isNaN(parseInt(getURLParameter("location")))) {
                overrides.location = "Pond" + parseInt(getURLParameter("location"));
            }
            // Note that rule is not the same as ruleset: rule is the index of the rule withing the available rules for the ruleSet
            if (!isNaN(parseInt(getURLParameter("rule")))) {
                overrides.rule = parseInt(getURLParameter("rule"));
            }
            if (getURLParameter("spots") != null) {
                const spots =  getURLParameter("spots").split(",").map(spot => parseInt(spot)).filter(spot => !isNaN(spot));
                overrides.spots = spots;
            }

            this._puzzles = PuzzleRandomizer.generatePuzzles(
                this.getValue("randomizedPuzzles"),
                this.getValue("locations"),
                rulesetIndex,
                7,
                false,
                overrides
            );

            this._practicePuzzles = PuzzleRandomizer.generatePuzzles(
                this.getValue("randomizedPracticePuzzles"),
                this.getValue("locationsPractice"),
                rulesetIndex,
                6,
                true,
                overrides
            );

            this.rulesetIndex = rulesetIndex;
        }

    }

    get puzzles() {
        return this._puzzles;
    }

    get practicePuzzles() {
        return this._practicePuzzles;
    }

    getPracticePuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.practicePuzzles.length
        }
        return this.practicePuzzles[idx];
    }

    getPuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.puzzles.length
        }
        return this.puzzles[idx];
    }

    getLocation(index) {
        return this.getValue(`locations`)[index];
    }

    getLocationSkin(index) {
        return this.getLocation(index).skin;
    }

    getItemName(index) {
        return this.getValue(`items`)[index];
    }

}